export default {
    languages: {
        en: 'English',
        es: 'Español',
        zh: '中文',
        label: 'Idioma',
        hint: 'Elige el idioma de la interfaz del sitio.',
    },
    common: {
        login: 'Iniciar sesión',
        register: 'Registrarse',
        dashboard: 'Panel',
        logout: 'Cerrar sesión',
        save: 'Guardar',
        cancel: 'Cancelar',
        continue: 'Continuar',
        loading: 'Cargando…',
        renew: 'Renovar',
        discord: 'Discord',
        getStarted: 'Empezar',
        learnMore: 'Saber más',
        back: 'Volver',
        apply: 'Aplicar',
        copy: 'Copiar',
        done: 'Listo',
        view: 'Ver',
        close: 'Cerrar',
        delete: 'Eliminar',
        create: 'Crear',
        search: 'Buscar',
        recommended: 'Recomendado',
        monthly: 'Mensual',
        lifetime: 'De por vida',
        basic: 'Basic',
        advanced: 'Advanced',
        purchase: 'Comprar',
        checkout: 'Pago',
        perMonth: '/mes',
        lifetimePrice: '{price} de por vida',
        confirm: 'Confirmar',
        submitting: 'Enviando…',
        sending: 'Enviando…',
        redeeming: 'Canjeando…',
        creating: 'Creando…',
        redirecting: 'Redirigiendo…',
        oneMonth: '1 mes',
    },
    nav: {
        documentation: 'Documentación',
        features: 'Funciones',
        pricing: 'Precios',
        modules: 'Módulos',
        updates: 'Novedades',
        videos: 'Videos',
        media: 'Media',
    },
    sidebar: {
        dashboard: 'Panel',
        purchase: 'Comprar',
        download: 'Descargar',
        modules: 'Módulos',
        playerList: 'Lista de jugadores',
        configs: 'Configs',
        scripts: 'Scripts',
        referrals: 'Referidos',
        reseller: 'Revendedor',
        media: 'Media',
        tickets: 'Tickets',
        guides: 'Guías',
        settings: 'Ajustes',
        manage: 'Administrar',
        logout: 'Cerrar sesión',
        license: 'Licencia',
        renew: 'Renovar',
        expires: 'Caduca {when}',
        expired: 'Caducó {when}',
    },
    auth: {
        loginTitle: 'Iniciar sesión',
        registerTitle: 'Registrarse',
        username: 'Usuario',
        password: 'Contraseña',
        email: 'Correo',
        confirmPassword: 'Confirmar contraseña',
        newPassword: 'Nueva contraseña',
        forgotPassword: '¿Olvidaste tu contraseña?',
        noAccount: '¿No tienes una cuenta?',
        hasAccount: '¿Ya tienes una cuenta?',
        twoFactorRequired: 'Autenticación en dos pasos requerida para {username}',
        twoFactorCode: 'Código de 6 dígitos',
        orRecovery: 'O usa un código de recuperación:',
        recoveryCode: 'Código de recuperación',
        backToLogin: 'Volver al login',
        verify: 'Verificar',
        forgotTitle: 'Olvidé mi contraseña',
        forgotHint: 'Introduce tu correo y te enviaremos un enlace para restablecerla.',
        sendReset: 'Enviar enlace',
        resetSent: 'Se envió un correo de restablecimiento — revisa tu bandeja.',
        resetTitle: 'Restablecer contraseña',
        resetHint: 'Introduce tu nueva contraseña.',
        resetSubmit: 'Restablecer contraseña',
        resetSuccess: '¡Listo! Tu contraseña se actualizó. Serás redirigido al login.',
        cooldown: 'Puedes enviar otra solicitud en {minutes} minutos',
    },
    home: {
        brand: 'Dream Client',
        subtitle:
            'Un cliente de Minecraft potente y personalizable, gestionado desde el navegador: seguro, actualizado y pensado para el rendimiento.',
        whyTitle: 'Por qué Dream',
        whySubtitle: 'Control, cobertura y ventaja frente a los anti-cheats.',
        featureControlTitle: 'Control remoto y en el juego',
        featureControlText:
            'Basic se controla desde la Web-GUI del navegador. Advanced añade menús externos e internos para ajustar módulos dentro del juego o desde cualquier lugar.',
        featureVersionsTitle: 'Versiones legacy y modernas',
        featureVersionsText:
            'Compatible con 1.7–1.8, 1.12.2 y builds Advanced modernas 1.20.6–26.2 — con módulos compartidos y exclusivos de 1.20+.',
        featureSecureTitle: 'Actualizado y protegido',
        featureSecureText:
            'Actualizaciones continuas frente a anti-cheats, datos cifrados y pagos seguros — para competir sin complicaciones.',
        pricingTitle: 'Precios y planes',
        pricingSubtitle: 'Las mismas tarifas que en el checkout — elige Basic o Advanced.',
        basicName: 'Dream Basic',
        advancedName: 'Dream Advanced',
        basicTag: 'Web-GUI',
        advancedTag: 'Menús externos + internos',
        basicBullet1: 'Web-GUI remota en el navegador',
        basicBullet2: 'Minecraft 1.7–1.8',
        basicBullet3: '21 módulos principales',
        basicBullet4: 'Windows 10 / 11',
        advancedBullet1: 'Menús externos + internos',
        advancedBullet2: '1.7–1.8, 1.12.2 y 1.20.6–26.2',
        advancedBullet3: 'Módulos compartidos + exclusivos 1.20+',
        advancedBullet4: 'Windows 10 / 11',
        viewModules: 'Ver módulos',
        getAdvanced: 'Obtener Advanced',
        resellerTeaser: '¿Quieres revender? Pack inicial ~$200 con 35% de descuento.',
        becomeReseller: 'Hazte revendedor',
        modulesTitle: 'Módulos',
        modulesSubtitle: 'Mira lo que incluye Basic y Advanced.',
        videosTitle: 'Videos',
        videosSubtitle: 'Mira Dream Client en acción.',
    },
    guestCheckout: {
        eyebrow: 'Compra directa',
        title: 'Elige tu acceso. Empieza en minutos.',
        subtitle: 'No necesitas crear una cuenta antes de pagar. Elige un plan, paga de forma segura y crea tu acceso desde la confirmación o el correo.',
        instant: 'Entrega instantánea',
        mobileAdvancedPopular: 'Advanced · Más popular',
        perMonthShort: '/mes',
        accountAfter: 'Cuenta después del pago',
        secure: 'Pago seguro con PayPal',
        chooseProduct: 'Elige tu Dream',
        chooseProductHint: 'Compara la cobertura antes de pagar.',
        from: 'Desde {price}',
        chooseAccess: 'Elige el acceso',
        monthly: 'Mensual',
        lifetime: 'De por vida',
        bestValue: 'Mejor valor',
        forOneMonth: 'por un mes',
        oneTime: 'pago único',
        updatesIncluded: 'Actualizaciones continuas',
        checkout: 'Pago seguro',
        checkoutHint: 'Tu plan queda vinculado a tu correo.',
        signedInTitle: 'Tu cuenta está lista para comprar',
        signedInBody: 'Continúa en el checkout completo del panel con tus ofertas y métodos de pago actuales.',
        openDashboardCheckout: 'Abrir checkout del panel',
        paymentComplete: 'Pago completado',
        successTitle: 'Tu acceso está reservado',
        successBody: 'Enviamos las instrucciones a {email}. También puedes crear tu cuenta ahora.',
        createAccountNow: 'Crear mi cuenta',
        emailBackup: 'El mismo enlace seguro está en tu correo.',
        emailLabel: '¿Dónde enviamos tu acceso?',
        emailPlaceholder: "tu{'@'}correo.com",
        emailHint: 'Solo lo usamos para el recibo, el acceso y la creación de la cuenta.',
        processing: 'Confirmando el pago y preparando tu acceso…',
        termsLead: 'Al pagar, aceptas los',
        termsLink: 'Términos del servicio',
        haveAccount: '¿Ya eres cliente?',
        signInInstead: 'Inicia sesión y usa el checkout del panel',
        paypalSecure: 'Procesado por PayPal',
        paypalPoweredBy: 'Desarrollado por',
        noAccountFirst: 'Sin cuenta previa',
        moreMethods: '¿Necesitas cripto u otro método? Crea una cuenta o inicia sesión para usar el checkout completo.',
        genericError: 'No se pudo iniciar el pago. Inténtalo de nuevo.',
        paypalUnavailable: 'PayPal no está disponible ahora. Usa el checkout de la cuenta.',
        validEmail: 'Introduce un correo válido antes de continuar.',
        cancelled: 'El pago se canceló. No se realizó ningún cargo.',
    },
    publicUpdates: {
        eyebrow: 'Desarrollo activo',
        title: 'Novedades recientes.',
        live: 'Actualizado regularmente',
        subtitle: 'Lanzamientos, mejoras y correcciones reales del changelog de Dream, visibles antes de comprar.',
        version: 'Dream {version}',
        more: '+{count} cambios más',
        empty: 'Las próximas novedades de Dream aparecerán aquí.',
        cta: 'Todos los planes incluyen actualizaciones para sus versiones compatibles.',
        seePlans: 'Elegir un plan',
    },
    claim: {
        eyebrow: 'Acceso listo',
        title: 'Crea tu cuenta de Dream',
        subtitle: 'Tu compra está completa. Elige las credenciales para entrar al panel y descargar.',
        purchasedFor: 'Correo de compra',
        invalid: 'Este enlace está incompleto o no es válido. Abre el enlace del correo de compra.',
        error: 'No pudimos completar la creación de la cuenta. Inténtalo de nuevo.',
        finishing: 'Creando tu cuenta…',
        submit: 'Crear cuenta y continuar',
        note: 'Tu compra queda vinculada a este correo verificado.',
    },
    dashboard: {
        eyebrow: 'Panel',
        welcome: 'Bienvenido de nuevo, {username}',
        sub: 'Resumen de tu cuenta, estadísticas del producto y los últimos changelogs.',
        joinDiscord: 'Unirse a Discord',
        createChangelog: 'Crear changelog',
        giveawaysTitle: 'Sorteos activos',
        giveawaysHint: 'Participa para ganar una licencia',
        enter: 'Participar',
        view: 'Ver',
        entered: 'Inscrito',
        youWon: 'Ganaste — toca para ver el premio',
        expires: 'Caduca {when}',
        drawn: 'Sorteado {when}',
        entries: '{count} inscripciones | {count} inscripción | {count} inscripciones',
        activityTitle: 'Lanzamientos y descargas',
        activityHint: 'Totales mensuales del año',
        changelogsTitle: 'Changelogs',
        userId: 'ID de usuario',
        totalUsers: 'Usuarios totales',
        totalLaunches: 'Lanzamientos totales',
        totalDownloads: 'Descargas totales',
        versionBasic: 'Versión Basic',
        versionAdvanced: 'Versión Advanced',
        communityEyebrow: 'Comunidad',
        activityEyebrow: 'Actividad',
        updatesEyebrow: 'Novedades',
        toastLoadFailed: 'Error al cargar la información',
    },
    download: {
        eyebrow: 'Dream loader',
        title: 'Prepara tu cliente',
        sub: 'Elige tu edición de Dream, define la identidad del loader y genera tu build de Windows con licencia.',
        licensed: 'Licencia vinculada',
        editionEyebrow: 'Edición del cliente',
        basicCopy: 'Control Web-GUI desde el navegador · Minecraft 1.7–1.8',
        advancedCopy: 'Control externo + en el juego · Soporte para versiones modernas',
        licenseLabel: 'Acceso',
        licenseBound: 'Build vinculada a tu cuenta',
        identityEyebrow: 'Identidad del loader',
        identityTitle: 'Define el ejecutable',
        outputLabel: 'Loader generado',
        timestampCustom: 'Marca personalizada',
        timestampRandom: 'Marca aleatoria',
        devBuildHint: 'Canal exclusivo para staff',
        buildSummary: 'Listo para generar',
        building: 'Generando loader…',

        buildActivity: 'Generando tu loader',
        buildProgressHint: 'Preparando una build con licencia para tu cuenta y edición seleccionada.',
        buildStageIdentity: 'Emitiendo el registro de distribución autenticado',
        buildStageDos: 'Aleatorizando los metadatos DOS',
        buildStageHeaders: 'Aplicando cabeceras COFF y PE',
        buildStageChecksum: 'Escribiendo checksum y marca de tiempo',
        buildStageImports: 'Reordenando descriptores de importación',
        buildStageSeal: 'Sellando el ejecutable con licencia',
        buildDownload: 'Generar y descargar',
        readinessEyebrow: 'Comprobación del sistema',
        appType: 'Tipo de aplicación',
        fileName: 'Nombre del ejecutable',
        fileNameHint: 'Por defecto AnyDesk.exe si lo dejas vacío',
        fileNamePlaceholder: 'AnyDesk.exe',
        timestamp: 'Marca de tiempo personalizada',
        timestampHint: 'Opcional — se usa una aleatoria si está vacío',
        download: 'Descargar',
        requirements: 'Requisitos',
        windows: 'Windows 10 / 11 x64',
        licenseNeeded: 'Licencia Basic o Advanced activa',
        os: 'SO',
        runtime: 'Runtime',
        osValue: 'Windows 10/11 x64',
        runtimeValue: 'VC++ Redistributable',
        devBuild: 'Descargar build de desarrollo',
        notesEyebrow: 'Notas',
        notesTitle: 'Antes de ejecutarlo',
        note1: 'Instala el runtime VC++ si Windows pide bibliotecas faltantes.',
        note2: 'Los nombres personalizados ayudan a mezclar el loader con otras herramientas.',
        note3: 'Deja la marca de tiempo vacía para obtener una hora de build aleatoria.',
    },
    purchase: {
        eyebrow: 'Pago',
        title: 'Comprar',
        sub: 'Elige un producto y un plan, luego paga.',
        upgradeEyebrow: 'Mejora',
        upgradeTitle: 'Mejorar a Advanced',
        upgradeSub: 'Ya tienes Dream Basic. Desbloquea módulos Advanced, versiones modernas y menús en el juego.',
        upgradeLead: 'Versiones modernas, menús en el juego y módulos extra — Basic sigue siendo tuyo.',
        upgradePerk1: 'Soporte 1.20.6–26.2',
        upgradePerk2: 'Menús externos + en el juego',
        upgradePerk3: 'Combate y utilidad Advanced',
        upgradePriceLabel: 'De por vida · {percent}% descuento de propietario',
        payUpgrade: 'Pagar mejora',
        continueToPay: 'Continuar al pago',
        seeWhatsNew: 'Ver novedades',
        buyAsGift: 'Comprar como regalo',
        becomeReseller: 'Hazte revendedor',
        openReseller: 'Abrir panel de revendedor',
        giftLinks: 'Enlaces de regalo sin canjear',
        yourGifts: 'Tus regalos',
        copyLink: 'Copiar enlace',
        allSetTitle: 'Todo listo',
        allSetSub:
            'Ya tienes Basic y Advanced. Activa {gift} arriba para comprar para un amigo, o usa {reseller} para vender claves.',
        product: 'Producto',
        plan: 'Plan',
        payNow: 'Pagar ahora',
        upgradeTotal: 'Total de la mejora',
        total: 'Total',
        payCrypto: 'Pagar con cripto',
        moreMethods: 'Más métodos de pago',
        viewModules: 'Ver módulos',
        partnerLabel: 'Partner destacado',
        partnerTitle: '¿Necesitas una cuenta de Minecraft?',
        partnerBody: 'Cuentas NFA y MFA económicas, incluidas cuentas con rangos de Hypixel o saldo de Donut SMP.',
        partnerCta: 'Ver tienda',
        partnerAria: 'Visitar fernan.club, tienda destacada de cuentas de Minecraft',
        acceptTerms: 'Aceptar términos',
        viewTerms: 'Ver términos',
        discountReferralKey: 'Descuento, referido o clave',
        discountCode: 'Código de descuento',
        referralCode: 'Código de referido',
        redeemKey: 'Canjear clave de licencia',
        redeem: 'Canjear',
        giftMonthlyNote: 'Las licencias mensuales de regalo incluyen 1 mes de acceso.',
        upgradeLocked: 'Producto bloqueado en Advanced al mejorar desde Basic.',
        upgradeFromBasic: 'Mejora desde Basic · {tag}',
        keepBasicNote: 'Estás mejorando desde Basic. Tu acceso Basic sigue activo.',
        lifetimeUpgradeDiscount: 'Mejora lifetime Basic · {percent}% dto.',
        discountApplied: '{percent}% de descuento aplicado',
        webGuiTag: 'Web-GUI · Minecraft 1.7–1.8',
        advancedTag: 'Menús externos + internos · 1.7–26.2',
        fixedMonths: 'Comprar meses fijos (sin renovación automática)',
        giftComplete: 'Compra completada',
        giftReady: 'Regalo listo para compartir',
        giftProcessing: 'Tu regalo se está preparando. Revisa «Tus regalos» en un momento si no aparece el enlace.',
        giftShareHint: 'Envía el enlace por Discord. Tu amigo lo canjea tras iniciar sesión. También te enviamos estos detalles por email.',
        redeemLink: 'Enlace de canje',
        backupKey: 'Clave de respaldo',
        copyShareLink: 'Copiar enlace',
        fixedMonthsHint: 'El acceso termina tras los meses seleccionados — tendrás que volver a comprar.',
        agreementEyebrow: 'Antes del pago',
        termsTitle: 'Términos de servicio',
        termsLead: 'Para comprar Dream debes aceptar nuestros términos de servicio.',
        toastGiftCopied: 'Enlace de regalo copiado',
        toastCopyLinkFailed: 'No se pudo copiar el enlace',
        toastKeyCopied: 'Clave copiada',
        toastCopyKeyFailed: 'No se pudo copiar la clave',
        toastKeyRedeemed: 'Clave canjeada correctamente',
        toastSomethingWrong: 'Algo salió mal',
        toastAssistantSelected: 'Seleccionado Dream {product} · {plan}{gift}',
        toastGiftSuffix: ' · Regalo',
        cryptoNoteTitle: 'Nota sobre criptomonedas',

        cryptoNoteBody: 'Ten en cuenta que si pagas con cripto el acceso puede no darse de inmediato. La transacción se procesará y recibirás el producto al completarse. Si no lo recibes en 24 horas, abre un ticket. NO intentes comprar de nuevo mientras haya una transacción pendiente: podrías perder fondos.',
    },
    settings: {
        eyebrow: 'Cuenta',
        title: 'Ajustes',
        sub: 'Gestiona tu cuenta Dream, seguridad y suscripciones.',
        languageEyebrow: 'Preferencias',
        languageTitle: 'Idioma',
        languageHint: 'Elige el idioma de la interfaz. Esto no cambia los Términos legales.',
        languageSaved: 'Idioma actualizado.',
        hardware: 'Hardware',
        profile: 'Perfil',
        security: 'Seguridad',
        staff: 'Staff',
        hwidTitle: 'HWID',
        hwidText: 'Ejecuta {dream} para copiar tu HWID cuando veas {auth}, y pégalo aquí.',
        lastUpdated: 'Última actualización',
        hwidSuccess: 'HWID actualizado. Ya puedes acceder a Dream.',
        usernameTitle: 'Usuario',
        usernameText: 'Cambia el nombre de usuario con el que inicias sesión.',
        usernameSuccess: 'Tu nombre de usuario se ha actualizado.',
        emailTitle: 'Correo',
        emailText: 'Obligatorio para migrar del sistema antiguo. Recibirás un email de verificación tras actualizar.',
        emailSuccess: 'Correo actualizado. Revisa tu bandeja para el enlace de verificación antes de usar Dream de nuevo.',
        updateEmail: 'Actualizar correo',
        passwordTitle: 'Cambiar contraseña',
        oldPassword: 'Contraseña antigua',
        updateHwid: 'Actualizar HWID',
        hwidPlaceholder: 'HWID',
        updateUsername: 'Actualizar usuario',
        changePassword: 'Cambiar contraseña',
        discordTitle: 'Vincular Discord',
        discordText: 'Pega tu ID de Discord para recibir menciones en tickets asignados a ti.',
        discordPlaceholder: 'ID de Discord',
        updateDiscord: 'Actualizar ID de Discord',
        twoFactorTitle: 'Autenticación en dos pasos',
        twoFactorHint: 'Añade un código de app autenticadora para más seguridad al iniciar sesión.',
        twoFactorDisabled: '2FA está actualmente {status}.',
        twoFactorEnabled: '2FA está actualmente {status}.',
        twoFactorStatusDisabled: 'desactivada',
        twoFactorStatusEnabled: 'activada',
        brandDream: 'Dream',
        notAuthenticated: 'Not Authenticated',
        enable2fa: 'Activar 2FA',
        disable2fa: 'Desactivar 2FA',
        step1Qr: 'Paso 1: Escanea el código QR',
        step1QrHint: 'Escanea con Google Authenticator, Authy o similar:',
        step2Code: 'Paso 2: Introduce el código',
        step2CodeHint: 'Introduce el código de 6 dígitos de tu app:',
        verifyEnable: 'Verificar y activar',
        viewRecovery: 'Ver códigos de recuperación',
        generateRecovery: 'Generar nuevos códigos',
        recoveryTitle: 'Códigos de recuperación',
        recoveryHint: 'Guárdalos en un lugar seguro. Cada código puede desbloquear tu cuenta si pierdes el dispositivo.',
        hideRecovery: 'Ocultar códigos',
        disable2faTitle: 'Desactivar autenticación en dos pasos',
        disable2faHint: 'Introduce tu contraseña y un código 2FA o de recuperación:',
        twoFactorOrRecovery: 'Código 2FA o de recuperación',
        never: 'Nunca',
        dangerZone: 'Zona de peligro',
        subscriptionsTitle: 'Suscripciones y cuenta',
        cancelSubscription: 'Cancelar suscripción',
        cancelBasicTitle: 'Cancelar suscripción PayPal Basic',
        cancelBasicText: 'Perderás el acceso Basic cuando expire el período actual.',
        cancelBasic: 'Cancelar Basic',
        cancelAdvancedTitle: 'Cancelar suscripción PayPal Advanced',
        cancelAdvancedText: 'Perderás el acceso Advanced cuando expire el período actual.',
        cancelAdvanced: 'Cancelar Advanced',
        deleteAccount: 'Eliminar cuenta',
        deleteAccountText: 'Elimina permanentemente tu cuenta Dream. Esta acción no se puede deshacer.',
        toastPasswordUpdated: 'Tu contraseña se ha actualizado',
        toastPasswordFailed: 'Error al actualizar la contraseña',
        toastVerifyFailed: 'Error al enviar la verificación',
        toastHwidUpdated: 'HWID actualizado',
        toastHwidFailed: 'Error al cambiar el HWID',
        toastUsernameUpdated: 'Usuario actualizado',
        toastUsernameFailed: 'Error al cambiar el usuario',
        toastDiscordUpdated: 'ID de Discord actualizado',
        toastDiscordFailed: 'Error al cambiar el ID de Discord',
        toastAccountDeleted: 'Tu cuenta ha sido eliminada',
        toastAccountDeleteFailed: 'Error al eliminar la cuenta',
        toastSubCancelledBasic: 'Tu suscripción Basic ha sido cancelada',
        toastSubCancelledAdvanced: 'Tu suscripción Advanced ha sido cancelada',
        toastSubCancelFailed: 'Error al cancelar la suscripción',
        toast2faSecretFailed: 'Error al generar el secreto 2FA',
        toast2faEnabled: '2FA activada en tu cuenta',
        toast2faEnableFailed: 'Error al activar 2FA',
        toast2faDisabled: '2FA desactivada en tu cuenta',
        toast2faDisableFailed: 'Error al desactivar 2FA',
        toastRecoveryViewFailed: 'Error al ver los códigos de recuperación',
        toastRecoveryGenerated: 'Nuevos códigos de recuperación generados',
        toastRecoveryGenerateFailed: 'Error al generar códigos de recuperación',

        dialogPasswordTitle: 'Cambiar contraseña',
        dialogPasswordText: '¿Seguro que quieres cambiar tu contraseña?',
        dialogDisable2faTitle: 'Desactivar 2FA',
        dialogDisable2faText: '¿Seguro que quieres desactivar la autenticación en dos pasos?',
        dialogRecoveryTitle: 'Generar nuevos códigos de recuperación',
        dialogRecoveryText: 'Esto generará nuevos códigos e invalidará los existentes. ¿Seguro?',
        dialogDeleteTitle: 'Introduce la contraseña',
        dialogDeleteText: 'Introduce tu contraseña para eliminar tu cuenta',
        dialogCancelSubTitle: 'Introduce la contraseña',
        dialogCancelSubText: 'Introduce tu contraseña para cancelar esta suscripción',
    },
    scripts: {
        ui: {
            "details": "Ver detalles",
            "deleteScript": "Eliminar script",
            "deleting": "Eliminando…",
            "delete": "Eliminar",
            "reading": "Leyendo script…",
            "startSource": "Empieza eligiendo tu archivo .luau",
            "prefill": "Se rellenan los datos de dream.module; puedes editar todo lo que aparece abajo.",
            "sourceHint": "UTF-8 · hasta 256 KiB. El archivo se lee localmente, nunca se ejecuta.",
            "idHint": "Usa author.module; cada parte necesita al menos 2 letras minúsculas, números, _ o -.",
            "nameHint": "Entre 3 y 64 caracteres.",
            "versionHint": "Versión semántica como 1.0.0 o 1.0.0-beta.1 (máx. 32).",
            "summaryHint": "Entre 10 y 240 caracteres.",
            "descriptionHint": "Entre 20 y 5.000 caracteres.",
            "visibility": "Visibilidad",
            "chooseVisibility": "Elige dónde estará disponible esta versión",
            "privateReadyHint": "Las versiones privadas estarán disponibles en tu loader tras las comprobaciones automáticas.",
            "ownerOnly": "Solo el propietario",
            "moderated": "Con moderación",
            "private": "Privado",
            "privateHint": "Solo tú puedes instalarlo. No requiere moderación.",
            "marketplaceHint": "Queda pendiente hasta que el equipo lo apruebe.",
            "chooseRuntime": "Elige un cliente",
            "runtimeHint": "Cada versión es compatible con una familia de clientes.",
            "required": "Obligatorio",
            "chooseCapabilities": "Elige qué utiliza el script",
            "capabilityHint": "El acceso al juego se comprueba durante la revisión.",
            "privateNotice": "Tras las comprobaciones automáticas, esta versión estará disponible solo en tu loader.",
            "localNotice": "Esta versión del marketplace permanece en la cola de moderación local de depuración.",
            "publicNotice": "Las versiones del marketplace siguen siendo privadas mientras esperan la moderación.",
            "uploadPrivate": "Subir script privado",
            "submitting": "Enviando…",
            "submitMarketplace": "Enviar al marketplace",
            "hideProfiles": "Ocultar perfiles en la nube",
            "cloudProfiles": "Perfiles en la nube",
            "noProfiles": "No hay perfiles en la nube guardados para este script.",
            "noPersonalProfiles": "Todavía no tienes perfiles en la nube para este script.",
            "enabled": "Activado",
            "disabled": "Desactivado",
            "checksPassed": "Comprobaciones automáticas superadas",
            "validationReport": "Informe de validación",
            "submittedSource": "Código Luau enviado",
            "openReview": "Abrir para revisar",
            "sourceUnavailable": "El código fuente no está disponible.",
            "author": "Autor",
            "about": "Acerca de este script",
            "personalStorage": "Almacenamiento personal",
            "myProfiles": "Mis perfiles en la nube",
            "close": "Cerrar",
            "unavailable": "No disponible",
            "on": "Activado",
            "off": "Desactivado",
            "unknown": "desconocido",
            "privateReady": "Privado - Listo",
            "marketplacePending": "Marketplace - Pendiente",
            "marketplacePublished": "Marketplace - Publicado",
            "marketplaceRejected": "Marketplace - Rechazado",
            "validationPassed": "Validación automática superada.",
            "submittedMarketplace": "Versión enviada a moderación del marketplace.",
            "privateUploaded": "Script privado validado y añadido a tu loader.",
            "localSubmitted": "Versión del marketplace enviada a la cola de moderación local.",
            "correctFields": "Corrige los campos resaltados antes de subir el script.",
            "fileSelected": "Archivo seleccionado. Se han conservado tus datos; completa los campos que falten.",
            "readError": "No se pudo leer el código. Guárdalo como texto UTF-8 y vuelve a elegirlo.",
            "fileRange": "Elige un archivo .luau de entre 1 byte y 256 KiB.",
            "sourceRange": "El archivo debe tener entre 1 byte y 256 KiB.",
            "chooseSource": "Elige un archivo de código .luau.",
            "sourceExtension": "Solo se aceptan archivos de código .luau.",
            "invalidName": "El nombre debe tener entre 3 y 64 caracteres.",
            "invalidSummary": "El resumen debe tener entre 10 y 240 caracteres.",
            "invalidDescription": "La descripción debe tener entre 20 y 5.000 caracteres.",
            "invalidRuntime": "Selecciona una sola familia de clientes de Minecraft.",
            "invalidVisibility": "Elige la visibilidad Privado o Marketplace.",
            "invalidCapabilities": "Elige como máximo 7 capacidades compatibles, sin duplicados.",
            "invalidId": "Usa author.module; cada parte necesita al menos 2 letras minúsculas, números, guiones bajos o guiones.",
            "invalidVersion": "Usa una versión semántica como 1.0.0 o 1.0.0-beta.1 (máximo 32 caracteres).",
            "deleteProfile": "Eliminar perfil en la nube",
            "deleteDreamScript": "Eliminar Dream Script",
            "localListing": "listado local de depuración",
            "productionListing": "listado de producción",
            "by": "Por {name}",
            "more": "+{count} más",
            "selected": "{count} seleccionadas",
            "saved": "{count} guardados",
            "savedValues": "{count} valores guardados",
            "pending": "{count} pendientes",
            "revision": "v{version} - revisión {revision}",
            "deleteNamed": "Eliminar {name}",
            "deleteProfileNamed": "Eliminar perfil en la nube {name}",
            "deleted": "Se ha eliminado {name}.",
            "confirmProfile": "¿Eliminar «{name}» de {script}? Esta acción no se puede deshacer.",
            "confirmScript": "¿Eliminar {id}? Se eliminarán permanentemente todas sus versiones y perfiles guardados en el {channel}. El otro canal no cambiará.",
            "imported": "Se han rellenado {fields}. Revisa la versión, el cliente y las capacidades antes de subirlo.",
            "worldData": "Datos del jugador y del mundo",
            "worldDataHint": "Leer copias seguras del estado del juego",
            "drawing": "Dibujo",
            "drawingHint": "Texto, líneas y formas",
            "playerControls": "Controles del jugador",
            "playerControlsHint": "Esprint y teclas de movimiento",
            "viewControl": "Control de la vista",
            "viewControlHint": "Giro horizontal y vertical",
            "combatActions": "Acciones de combate",
            "combatActionsHint": "Atacar o balancear la mano",
            "hotbarControl": "Control de la barra rápida",
            "hotbarControlHint": "Elegir casillas del 1 al 9",
            "worldInteraction": "Interacción con el mundo",
            "worldInteractionHint": "Usar bloques de forma segura"
        },
        eyebrow: 'Extensiones Advanced',
        title: 'Dream Scripts',
        subtitle: 'Descubre módulos revisados, publica código, gestiona perfiles en la nube desde el loader y aprende la API segura.',
        memoryOnly: 'Cliente solo en memoria',
        memoryOnlyHint: 'Se descarga por sesión; ningún script o perfil se guarda en disco.',
        marketplace: 'Marketplace', mine: 'Mis scripts', docs: 'Documentación', review: 'Revisión',
        search: 'Buscar scripts', allRuntimes: 'Todas las versiones', modern: 'Moderno 1.20+', legacy: 'Legacy 1.7.10 / 1.8.9 / 1.12.2',
        mostLoaded: 'Más usados', newest: 'Más nuevos', refresh: 'Actualizar', loads: 'cargas',
        loaderOnly: 'Ábrelo desde el loader de Dream para ejecutarlo en memoria.',
        emptyMarketplace: 'No hay scripts revisados', emptyMarketplaceHint: 'Prueba otro filtro o publica el primer módulo.',
        publishEyebrow: 'Herramientas de autor', publishTitle: 'Enviar una versión', scriptId: 'ID del script', name: 'Nombre',
        version: 'Versión', summary: 'Resumen', description: 'Descripción', compatibility: 'Compatibilidad', permissions: 'Capacidades',
        chooseSource: 'Elige un archivo fuente .luau', reviewNotice: 'Cada versión será privada hasta que el equipo la apruebe.',
        uploading: 'Subiendo…', submitReview: 'Enviar a revisión', yourScriptsEyebrow: 'Historial', yourScripts: 'Tus scripts',
        noUploads: 'Todavía no has subido scripts.', submitted: 'Versión enviada a revisión.',
        reviewEyebrow: 'Moderación', reviewTitle: 'Versiones pendientes', reviewNote: 'Nota de revisión', approve: 'Aprobar', reject: 'Rechazar',
        reviewEmpty: 'No hay versiones pendientes.', reviewSaved: 'Revisión guardada.',
        docsEyebrow: 'API versión 1', docsTitle: 'Crea un módulo Dream seguro',
        docsIntro: 'Luau usa una API de capacidades pequeña y compartida por legacy y modern. Los scripts nunca reciben handles nativos ni acceso al sistema operativo.',
        genericError: 'La solicitud del script ha fallado.',
    },

    configs: {
        eyebrow: 'Presets',
        title: 'Configs',
        sub: 'Explora presets según los módulos que usan, vota las mejores configs y aplícalas con un clic.',
        showing: 'Mostrando',
        publish: 'Publicar',
        filterAll: 'Todas',
        filterMine: 'Mías',
        filterPrivate: 'Privadas',
        filterPublic: 'Públicas',
        filterOfficial: 'Oficiales',
        sortTop: 'Top',
        sortNew: 'Nuevas',
        versionModern: '1.20+',
        versionLegacy: '1.7–1.12',
        upvote: 'Votar a favor',
        downvote: 'Votar en contra',
        moduleCount: '{n} módulo | {n} módulos',
        noModules: 'Ningún módulo personalizado',
        previewSettings: 'Ver ajustes',
        hideSettings: 'Ocultar ajustes',
        previewTitle: 'Ajustes de la config',
        previewSummary: '{modules} módulos · {settings} ajustes modificados',
        previewReadOnly: 'Solo lectura',
        settingCount: '{n} ajuste | {n} ajustes',
        customizedCount: '{n} personalizados',
        enabled: 'Activado',
        boundTo: 'Tecla: {key}',
        disabled: 'Desactivado',
        notSet: 'Sin definir',
        noModuleSettings: 'Sin ajustes adicionales',
        noPreviewSettings: 'No hay ajustes ni teclas de módulos modificados para mostrar.',
        use: 'Usar',
        delete: 'Eliminar config',
        emptyTitle: 'No se encontraron configs',
        emptySub: 'Prueba otro filtro, o publica tu setup actual para que otros lo usen.',
        publishCta: 'Publicar una config',
        publishTitle: 'Publicar config',
        publishSub: 'Comparte tu setup actual de Dream. Privada solo para ti; pública visible para todos. Oficial reservada al staff.',
        backToList: 'Volver a configs',
        visibility: 'Visibilidad',
        visibilityHint: 'Elige quién puede ver esta config en el navegador.',
        nameLabel: 'Nombre de la config',
        nameHint: '5–50 caracteres',
        namePlaceholder: 'Nombre de la config',
        descriptionLabel: 'Descripción',
        descriptionHint: '10–300 caracteres — servidores, estilo de juego, notas',
        descriptionPlaceholder: 'Descripción de la config',
        publishSuccess: 'Config publicada correctamente.',
        publishing: 'Publicando…',
        tipsEyebrow: 'Consejos',
        tipsTitle: 'Antes de publicar',
        tip1: 'Usa un nombre claro para que otros la encuentren rápido.',
        tip2: 'Menciona el servidor o estilo de juego en la descripción.',
        tip3: 'Las configs privadas solo las ves tú.',
        tip4: 'Publicar guarda una captura de tus ajustes de módulos actuales.',
        toastLoadFailed: 'Error al cargar las configs',
        toastOwnVote: 'No puedes votar tu propia config',
        toastVoteFailed: 'Error al votar',
        dialogUseTitle: 'Usar config',
        dialogUseText: '¿Seguro que quieres usar esta config? Sobrescribirá tu config actual.',
        toastApplied: 'Config aplicada',
        toastUseFailed: 'Error al usar la config',
        dialogDeleteTitle: 'Eliminar config',
        dialogDeleteText: '¿Seguro que quieres eliminar esta config?',
        toastDeleted: 'Config eliminada',
        toastDeleteFailed: 'Error al eliminar la config',
    },
    supportAssistant: {
        eyebrow: 'Asistente de soporte Dream', title: 'Asistente Dream', hint: 'Pregunta sobre Dream Basic o Advanced antes de crear un ticket.', launchHint: 'Respuestas rápidas sobre configs, módulos, HWID, media y compras', headerHint: 'Soporte Dream · algunas respuestas son automáticas',
        clear: 'Borrar conversación', collapse: 'Cerrar asistente', greeting: '¡Hola! Puedo ayudarte a encontrar ajustes y pasos de solución para Dream. Haz una pregunta o elige un tema.',
        examplesLabel: 'Preguntas de ejemplo', examples: 'Prueba una de estas:', exampleConfig: 'Cargar una config', exampleModules: 'Buscar ajustes de módulos', exampleHwid: 'Solucionar un HWID inválido', exampleMedia: 'Solicitudes de media', examplePurchase: 'Opciones de compra',
        promptConfig: '¿Cómo cargo una config para Dream?', promptModules: '¿Dónde encuentro la lista y los ajustes de módulos?', promptHwid: 'Me aparece un error de HWID inválido. ¿Qué debo comprobar?', promptMedia: '¿Cómo envío una solicitud de media?', promptPurchase: '¿Qué opciones de compra hay para Dream?',
        historyLabel: 'Conversación', you: 'Tú', assistant: 'Asistente Dream', handoff: '¿Aún necesitas ayuda?', createTicket: 'Crear un ticket de soporte', openSource: 'Abrir {title}',
        loading: 'Pensando…', error: 'El asistente de soporte no está disponible ahora. Inténtalo de nuevo o crea un ticket.',
        productLabel: 'Producto Dream', productAll: 'Todos', questionLabel: 'Tu pregunta', placeholder: 'Escribe una pregunta…',
        ask: 'Enviar', privacy: 'Enter envía · Shift + Enter añade una línea. No incluyas contraseñas, claves de licencia, datos de pago ni otros secretos. El chat solo se conserva durante esta sesión.',
    },
    tickets: {
        eyebrow: 'Soporte',
        title: 'Tickets',
        sub: 'Crea y sigue tickets de soporte. Elige la categoría correcta para que el staff te ayude más rápido.',
        showing: 'Mostrando',
        department: 'Departamento',
        create: 'Crear ticket',
        submit: 'Enviar ticket',
        titlePlaceholder: 'Título del ticket',
        detailHint: 'Introduce los detalles de tu ticket en el siguiente área de texto. Sé lo más descriptivo posible para ayudarnos a resolverlo más rápido',
        bodyPlaceholder: 'Empieza a escribir tu ticket aquí...',
        replyPlaceholder: 'Respuesta',
        send: 'Enviar',
        replied: 'Respondido',
        createdLabel: 'Creado',
        refresh: 'Actualizar',
        refreshAria: 'Actualizar tickets',
        filterAria: 'Filtro de tickets',
        showClosed: 'Mostrar tickets cerrados',
        assignedBadge: 'Asignado',
        filterAny: 'Cualquiera',
        filterMine: 'Míos',
        filterDepartment: 'Departamento',
        filterAssigned: 'Asignados',
        filterUnassigned: 'Sin asignar',
        emptyTitle: 'No se encontraron tickets',
        emptySub: 'Prueba otro filtro o crea un nuevo ticket de soporte.',
        deleteAria: 'Eliminar ticket',
        deleteReplyAria: 'Eliminar respuesta',
        allTickets: 'Todos los tickets',
        assignedTo: 'Asignado a {username}',
        ticketNumber: 'Ticket #{id}',
        loadingTicket: 'Cargando ticket…',
        assignStaff: 'Asignar staff',
        details: 'Detalles',
        labelTitle: 'Título',
        labelCategory: 'Categoría',
        labelCreator: 'Creador',
        labelCreated: 'Creado',
        labelAssigned: 'Asignado',
        unassigned: 'Sin asignar',
        stateOpen: 'Abierto',
        stateClosed: 'Cerrado',
        stateLocked: 'Bloqueado',
        confirmCloseTitle: 'Confirmar cierre',
        confirmCloseText: '¿Seguro que quieres cerrar este ticket? Los tickets no se pueden reabrir y tendrás que crear uno nuevo.',
        confirmDeleteTitle: 'Confirmar eliminación',
        confirmDeleteText: '¿Seguro que quieres eliminar este ticket?',
        confirmDeleteReplyText: '¿Seguro que quieres eliminar esta respuesta?',
        loadFailed: 'Error al cargar los tickets',
        loadTicketFailed: 'No se pudo cargar el ticket',
        closeFailed: 'Error al cerrar el ticket',
        deleteFailed: 'Error al eliminar el ticket',
        loadRepliesFailed: 'Error al cargar las respuestas',
        sendReplyFailed: 'Error al enviar la respuesta',
        deleteReplyFailed: 'Error al eliminar la respuesta',
        deptTechnical: 'Soporte técnico',
        deptSales: 'Ventas',
        deptDetections: 'Detecciones',
        deptSuggestions: 'Sugerencias',
        deptMedia: 'Solicitud de media',
        deptOther: 'Otro',
    },
    reseller: {
        eyebrow: 'Panel de revendedor',
        title: 'Centro de licencias',
        sub: 'Crea facturas al por mayor, sigue pagos y desbloquea claves — todo en un sitio.',
        discount: 'Tu descuento',
        unusedKeys: 'Claves sin usar',
        redeemed: 'Canjeadas',
        keysInCart: 'Claves en el carrito',
        storefront: 'Página de canje con marca',
        copyLink: 'Copiar enlace',
        tabPurchase: 'Comprar',
        tabInvoices: 'Facturas',
        tabStock: 'Stock',
        tabTools: 'Herramientas',
        bulkPurchase: 'Compra al por mayor',
        bulkPurchaseSub: 'Combina planes y paquetes en una sola factura.',
        licenseN: 'Licencia {n}',
        remove: 'Quitar',
        plan: 'Plan',
        package: 'Paquete',
        quantity: 'Cantidad',
        addLicenseType: 'Añadir otro tipo de licencia',
        basicMonthly: 'Basic mensual',
        basicLifetime: 'Basic de por vida',
        advancedMonthly: 'Advanced mensual',
        advancedLifetime: 'Advanced de por vida',
        orderSummary: 'Resumen del pedido',
        readyToInvoice: 'Listo para facturar',
        total: 'Total',
        includesDiscount: 'Incluye {percent}% de descuento de revendedor',
        listPriceHint: 'Los precios unitarios de arriba son de lista antes de tu descuento.',
        createInvoice: 'Crear factura',
        invoicesTitle: 'Facturas',
        invoicesSub: 'Las facturas pagadas desbloquean sus claves de licencia.',
        colId: 'ID',
        colDetails: 'Detalles',
        colQuantity: 'Cantidad',
        colStatus: 'Estado',
        colDate: 'Fecha',
        colActions: 'Acciones',
        paid: 'Pagada',
        unpaid: 'Sin pagar',
        pageN: 'Página {n}',
        prev: 'Anterior',
        next: 'Siguiente',
        keyStock: 'Stock de claves',
        keyStockSub: 'Claves generadas a partir de tus facturas pagadas.',
        exportUnused: 'Exportar sin usar',
        filterAll: 'Todas',
        filterUnused: 'Sin usar',
        filterUsed: 'Usadas',
        anyType: 'Cualquier tipo',
        anyPlan: 'Cualquier plan',
        colKey: 'Clave',
        colType: 'Tipo',
        colPlan: 'Plan',
        used: 'Usada',
        unused: 'Sin usar',
        stockTotal: '{n} en total',
        salesAnalytics: 'Analítica de ventas',
        salesAnalyticsSub:
            'Beneficio estimado a precio de lista (tu descuento mayorista del {percent}%) · últimos 30 días',
        allTimeProfit: 'Beneficio histórico',
        allTimeProfitDetail: "· {'$'}{spend} gastados · {keys} claves",
        profit30d: 'Beneficio (30d)',
        profitHint: "De claves canjeadas {'@'} lista",
        openMargin: 'Margen abierto',
        openMarginHint: "Stock sin usar si se vende {'@'} lista",
        spent30d: 'Gastado (30d)',
        sellThrough: 'Rotación',
        sellThroughHint: '{n} compradas · 30d',
        salesChartAria: 'Beneficio estimado y gasto mayorista en los últimos 30 días',
        salesChartEmpty:
            'Aún no hay actividad — el beneficio aparece cuando los clientes canjean tus claves (estimado a precio de lista).',
        purchaseMix: 'Mix de compras (30d)',
        mixChartAria: 'Claves compradas por tipo de producto',
        mixChartEmpty: 'Aún no hay compras',
        marginCalculator: 'Calculadora de margen',
        marginCalculatorSub: 'Tienes un {percent}% de descuento sobre lista. Introduce tu precio de venta para ver el beneficio.',
        product: 'Producto',
        sellPrice: 'Tu precio de venta ($)',
        matchList: 'Igualar lista',
        breakEven: 'Punto de equilibrio',
        list: 'Lista',
        yourCost: 'Tu coste',
        profitPerKey: 'Beneficio / clave',
        marginPercentLabel: '{n}% de margen',
        redemptions: 'Canjes',
        redemptionsSub: 'Canjes diarios de claves de tu stock · últimos 30 días',
        redemptionsTotal: 'Total',
        bestDay: 'Mejor día',
        activeDays: 'Días activos',
        redemptionsChartAria: 'Canjes en los últimos 30 días',
        redemptionsChartEmpty: 'Aún no hay canjes — el gráfico se rellena cuando los clientes usan tus claves.',
        invoiceN: 'Factura #{id}',
        status: 'Estado',
        details: 'Detalles',
        payInvoice: 'Pagar factura',
        sandboxMode: 'MODO SANDBOX ACTIVADO',
        payWithCrypto: 'Pagar con cripto',
        keys: 'Claves',
        toastLoadStockFailed: 'Error al cargar el stock',
        toastCopiedUnused: 'Se copiaron {count} claves sin usar',
        toastExportFailed: 'Error al exportar',
        toastCopied: 'Copiado',
        toastCopyFailed: 'Error al copiar',
        toastInvoiceCreated: 'Factura creada correctamente',
        toastInvoiceCreateFailed: 'Error al crear la factura',
        deleteInvoiceTitle: 'Eliminar factura',
        deleteInvoiceConfirm: '¿Seguro que quieres eliminar esta factura?',
        toastInvoiceDeleted: 'Factura eliminada',
        toastInvoiceDeleteFailed: 'Error al eliminar la factura',
        toastLoadInvoiceFailed: 'Error al cargar los detalles de la factura',
        toastPaymentCreateFailed: 'Error al crear el pago',
        toastPaymentSuccess: '¡Pago correcto! Claves generadas.',
        toastPaymentVerifyFailed: 'Error al verificar el pago',
        cryptoPaymentTitle: 'Pago con cripto',
        cryptoPaymentConfirm: '¿Pagar con cripto?',
        toastCryptoInitiated: 'Pago con cripto iniciado...',
        toastPaymentUrlFailed: 'No se pudo obtener la URL de pago',
        toastCryptoCreateFailed: 'Error al crear el pago con cripto',
        chartRedemptions: 'Canjes',
        chartRedeemed: '{n} canjeadas',
        chartProfit: 'Beneficio ($)',
        chartSpend: 'Gasto ($)',
        chartKeysBought: 'Claves compradas: {n}',
        chartKeys: 'Claves',
        chartKeysCount: '{n} claves',
    },
    guides: {
        eyebrow: 'Ayuda',
        title: 'Guías',
        sub: 'Artículos de configuración, bypass y solución de problemas.',
        search: 'Buscar guías',
        showing: 'Mostrando',
        create: 'Crear guía',
        view: 'Ver guía',
        emptyTitle: 'No se encontraron guías',
        emptySub: 'Prueba otra categoría, o crea una nueva guía si tienes acceso.',
        filterAll: 'Todas',
        filterBypass: 'Bypass',
        filterSetup: 'Setup',
        filterTroubleshoot: 'Solución de problemas',
        filterAria: 'Filtro de guías',
    },
    modules: {
        browserControl: 'Control desde el navegador',
        workspaceHint: 'Tus módulos, configurados a tu manera.',
        connected: 'Conectado',
        waiting: 'Esperando al cliente',
        stopped: 'Detenido',
        globalSettings: 'Ajustes globales',
        globalHint: 'Preferencias que se aplican a todos tus módulos.',
        settingsHint: 'Los cambios se guardan automáticamente al ajustar la configuración.',
        saving: 'Guardando cambios…',
        saved: 'Todos los cambios guardados',
        saveFailed: 'No se pudieron guardar los cambios. Inténtalo de nuevo.',
        more: 'Más',
        library: 'Biblioteca de módulos',
        search: 'Buscar un módulo…',
        active: 'activos',
        enabled: 'Activado',
        disabled: 'Desactivado',
        toggleModule: 'Activar {name}',
        noResults: 'No hay módulos que coincidan con tu búsqueda.',
        chooseModule: 'Elige un módulo para configurarlo',
        keybind: 'Tecla asignada',
        keybindHint: 'Asigna una tecla para activar este módulo en el juego.',
        boundHint: 'Usa {key} en el juego o borra la tecla asignada para controlar el módulo desde el navegador.',
        bindingHint: 'Pulsa una tecla para asignarla. Escape borra la asignación.',
        pressKey: 'Pulsa una tecla…',
        notBound: 'Sin asignar',
        clear: 'Borrar',
        retry: 'Reintentar',
        ready: 'Todo listo para empezar',
        startWorkspaceHint: 'Inicia la sesión aquí y conecta el cliente Dream para gestionar tus módulos. Destruir finaliza la sesión.',
        categories: { all: 'Todos', combat: 'Combate', visual: 'Visual', utility: 'Utilidades' },
        themes: { cards: 'Tarjetas', wide: 'Tarjetas anchas', workspace: 'Panel' },
        expandSettings: 'Mostrar ajustes de {name}',
        collapseSettings: 'Ocultar ajustes de {name}',
        inGame: 'En el juego',
        boundTo: 'Asignado a {key}',
        title: 'Módulos',
        running: 'En ejecución',
        notConnected: 'No conectado',
        start: 'Iniciar',
        destruct: 'Destruir',
        switchTheme: 'Cambiar tema',
        popOut: 'Abrir en ventana',
        publishConfig: 'Publicar config',
        startHint:
            'Para evitar detecciones, Dream no se ejecuta hasta que lo inicies aquí en el Web-GUI — pulsa Iniciar. Para dejar de detectarte, pulsa Destruir y detén el cheat.',
        toastStartFailed: 'Error al cambiar el estado de inicio',
        toastLoadFailed: 'Error al cargar los módulos',
    },
    gifts: {
        eyebrow: 'Licencia de regalo',
        title: 'Alguien te envió Dream',
        goHome: 'Ir al inicio',
        alreadyRedeemed: 'Este regalo ya fue canjeado.',
        loginHint: 'Inicia sesión o crea una cuenta para canjear este regalo.',
        redeem: 'Canjear regalo',
        openDashboard: 'Abrir panel',
        notFound: 'Regalo no encontrado',
        toastSuccess: 'Regalo canjeado — bienvenido a Dream',
        toastFailed: 'No se pudo canjear el regalo',
        productLine: 'Dream {product} · {plan}',
    },
    storefront: {
        eyebrow: 'Revendedor autorizado',
        sub: 'Canjea una clave de licencia Dream comprada a este revendedor.',
        keyLabel: 'Clave de licencia',
        loginHint: 'Inicia sesión o regístrate para canjear. Te traeremos de vuelta aquí.',
        redeem: 'Canjear clave',
        notFound: 'Tienda no encontrada',
        toastSuccess: 'Clave canjeada',
        invalidKey: 'Clave inválida o ya usada',
    },
    banned: {
        code: 'Baneado',
        title: 'Tu cuenta ha sido baneada y no puede acceder a Dream Client.',
        submitLabel: 'Enviar apelación de ban',
        deniedHint: 'Tu apelación anterior fue denegada{note}. Puedes enviar una nueva.',
        deniedNote: ': {note}',
        countryLabel: 'País',
        countryPlaceholder: '¿Dónde te encuentras?',
        ispLabel: 'ISP / proveedor de internet',
        ispPlaceholder: 'ej. Movistar, Claro, Starlink…',
        whyBannedLabel: '¿Por qué crees que tu cuenta fue baneada?',
        whyBannedPlaceholder: 'Describe qué crees que provocó el ban…',
        sharedLabel: '¿Has compartido tu cuenta?',
        sharedYes: 'Sí',
        sharedNo: 'No',
        sharedRequired: 'Indica si has compartido tu cuenta.',
        messagePlaceholder: 'Cualquier otra información que quieras añadir (opcional)…',
        additionalLabel: 'Detalles adicionales (opcional)',
        submit: 'Enviar apelación',
        staffNote: 'Nota del staff:',
        replyPlaceholder: 'Responder al staff…',
        sendReply: 'Enviar respuesta',
        submitNew: 'Enviar nueva apelación',
        statusOpen: 'En revisión',
        statusAccepted: 'Aceptada',
        statusDenied: 'Denegada',
        loadReasonFailed: 'No se pudo cargar el motivo del ban',
        toastLoadFailed: 'Error al cargar la apelación',
        toastAccepted: '¡Tu apelación fue aceptada — bienvenido de nuevo!',
        toastSubmitted: 'Apelación enviada',
        toastSubmitFailed: 'Error al enviar la apelación',
        toastReplyFailed: 'Error al enviar la respuesta',
    },
    assistant: {
        eyebrow: 'Ayuda rápida',
        title: '¿No sabes qué plan?',
        sub: 'Unas preguntas rápidas — te recomendamos la mejor opción.',
        skip: 'Omitir',
        launch: '¿No sabes qué plan? Obtén una recomendación',
        qVersion: '¿Qué versión de Minecraft juegas?',
        qPlaystyle: '¿Qué te importa más?',
        qCommitment: '¿Cómo quieres empezar?',
        qProduct: '¿Qué producto te encaja?',
        combat: 'PvP / combate',
        visuals: 'Visuales / ESP',
        utility: 'Utilidad / QoL',
        everything: 'Un poco de todo',
        tryMonthly: 'Probar mensual',
        buyLifetime: 'Comprar de por vida',
        giftFriend: 'Regalo para un amigo',
        basicTitle: 'Dream Basic',
        basicSub: 'Web GUI · pensado para 1.7–1.8',
        advancedTitle: 'Dream Advanced',
        advancedSub: 'También funciona en 1.7–1.8 · más menús',
        recommended: 'Recomendado para ti',
        giftBadge: 'Regalo',
        usePlan: 'Usar este plan',
        startOver: 'Empezar de nuevo',
        whyCombat: ' Buena opción si tu prioridad es PvP / combate.',
        whyVisuals: ' Buen encaje si te importan más ESP / visuales.',
        whyUtility: ' Ideal si quieres inventario, macros y herramientas QoL.',
        whyEverything: ' Pensado para quienes quieren un kit completo.',
        whyBasic78: 'Dream Basic está hecho para Minecraft 1.7–1.8 (web GUI).',
        whyAdvanced78: 'Dream Advanced también soporta 1.7–1.8, con menús externos + internos.',
        whyLegacy12: '1.12 está soportado por Dream Advanced (menús externos + internos).',
        whyModern: '1.20+ requiere Dream Advanced (menús externos + internos).',
        whyGift: ' Regalo de por vida — tu amigo canjea el enlace tras iniciar sesión.',
        whyMonthly: ' Lo mensual te permite probar antes de comprometerte.',
        whyLifetime: ' De por vida es la mejor relación calidad-precio si piensas quedarte.',
        productBasic: 'Dream Basic',
        productAdvanced: 'Dream Advanced',
    },
    becomeReseller: {
        badge: 'Revendedor',
        title: 'Hazte revendedor',
        lead: "Paga ~{'$'}{amount} por un pack inicial con {percent}% de descuento y vende claves desde el Panel de revendedor.",
        namePlaceholder: 'Nombre o web del revendedor',
        confirm: 'Entiendo que recibo claves de licencia para revender y que esta compra no es reembolsable.',
        continue: 'Continuar al pago',
        totalDue: 'Total a pagar:',
        toastCreateFailed: 'Error al crear la factura de activación',
        toastPaymentFailed: 'Error al crear el pago',
        toastWelcome: '¡Bienvenido! Pack de revendedor desbloqueado.',
        toastVerifyFailed: 'Error al verificar el pago',
        toastPaypalFailed: 'Error al cargar PayPal',
        toastPaymentUrlFailed: 'No se pudo obtener la URL de pago',
        toastCryptoFailed: 'Error al crear el pago con cripto',
        itemLabel: '{pkg} {plan}',
    },
    trustedResellers: {
        eyebrow: 'Opciones de pago',
        title: 'Nuestros revendedores de confianza',
        lead: 'Compra a través de un revendedor autorizado con tarjeta, wallet, transferencia, cripto y más. Tras la compra recibirás un email con los siguientes pasos.',
        altMethods: '+ Métodos de pago alternativos',
        empty: 'No hay revendedores de confianza disponibles ahora. Inténtalo más tarde o usa otro método de pago.',
        visit: 'Visitar {name}',
        loadError: 'No se pudieron cargar los revendedores de confianza. Inténtalo de nuevo.',
        methodsAria: 'Métodos de pago aceptados',
        sitesAria: 'Sitios de revendedores',
        methodCard: 'Débito | Crédito | Prepago',
        methodApple: 'Apple Pay',
        methodGoogle: 'Google Pay',
        methodBank: 'Transferencia bancaria (US, SEPA Direct)',
        methodCashApp: 'CashApp',
        methodCrypto: 'Criptomoneda',
        methodIdeal: 'iDEAL',
    },
    cryptoCheckout: {
        title: 'Pagar con cripto',
        subtitle: 'Quédate en Dream — elige una moneda y envía el importe exacto.',
        pickCoin: 'Elige criptomoneda',
        popular: 'Populares',
        allCoins: 'Todas las monedas',
        search: 'Buscar monedas…',
        continue: 'Continuar',
        selected: 'Seleccionada',
        sandbox: 'Sandbox',
        sandboxCase: 'Caso de prueba',
        sendExactly: 'Envía exactamente',
        toAddress: 'A esta dirección',
        copyAddress: 'Copiar dirección',
        copied: 'Dirección copiada',
        fiatTotal: 'Total del pedido',
        status: 'Estado',
        waiting: 'Esperando el pago',
        confirming: 'Confirmando…',
        successTitle: 'Pago recibido',
        successBody: 'Tu acceso se está desbloqueando. Puedes continuar al panel.',
        goDashboard: 'Ir al panel',
        failedTitle: 'Pago fallido',
        failedBody: 'Este pago no se completó. Puedes intentarlo de nuevo con otra moneda.',
        retry: 'Intentar de nuevo',
        close: 'Cerrar',
        creating: 'Creando pago…',
        expires: 'Expira',
        note: 'Envía solo la moneda seleccionada a esta dirección. El acceso se desbloquea cuando la red confirme el pago.',
    },
    dialogs: {
        inputPlaceholder: 'Valor',
    },
    message: {
        eyebrow: 'Anuncio',
        title: 'Mensaje recibido',
    },
    migrate: {
        title: '¡Bienvenido de nuevo!',
        body: 'Hola, cliente recurrente — hay una actualización de Dream Client y ahora necesitamos un email por seguridad y recuperación de contraseña. No podrás usar Dream Client hasta que añadas uno.',
        success: 'Se envió un email de confirmación — revisa tu bandeja.',
        submit: 'Enviar confirmación',
        toastFailed: 'Error al enviar la verificación',
    },
    verifyEmail: {
        verifying: 'Verificando email…',
        toastFailed: 'Error al verificar el email',
    },
    notFound: {
        title: 'Página no encontrada',
        text: 'No se pudo encontrar la página solicitada.',
        cta: 'Volver al inicio',
    },
    referrals: {
        eyebrow: 'Programa de medios',
        title: 'Referidos',
        sub: 'Gana dinero por cada usuario que se registre en Dream con tu código de referido.',
        openTicket: 'Abrir ticket',
        currentUses: 'Usos actuales',
        totalUses: 'Usos totales',
        availableEarnings: 'Ganancias disponibles',
        withdrawAt: 'Retiro desde',
        empty: 'Aún no hay una cuenta de referidos vinculada a este usuario.',
        linkEyebrow: 'Tu enlace',
        shareTitle: 'Comparte y gana',
        shareText: 'Envía este enlace a tu audiencia. Los retiros se habilitan al alcanzar {amount}: luego abre un ticket en la categoría {category}.',
        withdrawReady: 'Has alcanzado el mínimo para retirar. Abre un ticket para recibir tus ganancias.',
        copyLink: 'Copiar enlace de referido',
        howItWorks: 'Cómo funciona',
        payoutsTitle: 'Pagos',
        step1: 'Los usuarios que se unan con tu código cuentan para tus usos.',
        step2: 'Las ganancias se desbloquean en {amount}.',
        step3: 'Solicita el pago mediante un ticket en la categoría {category}.',
        loadError: 'No se pudieron cargar las ganancias de referidos',
    },
    media: {
        hero: {
            title: 'Muestra Dream en acción.',
            titleAccent: 'Consigue una licencia para crear.',
            copy: 'Crea vídeos, clips o directos de Minecraft con Dream. Los creadores aceptados reciben licencias temporales del producto a cambio de un plan de contenido acordado, además de soporte directo de nuestro equipo de medios.',
            signIn: 'Inicia sesión para solicitar acceso',
            startApplication: 'Comienza tu solicitud',
            openWorkspace: 'Abre tu espacio de trabajo',
            assurance: 'Las licencias están vinculadas a tu cuenta de Dream y a tu plan de contenido',
            create: 'Crea',
            publish: 'Publica',
            grow: 'Crece',
            caption: 'Licencia · crea · publica',
        },
        overview: {
            title: 'Elige el nivel que mejor encaje con tu canal',
            copy: 'No exigimos una cantidad semanal ni mensual de publicaciones. Publica cuando estés listo: cada vídeo aprobado añade 1 semana para Creador de prueba o 1 mes para Creador establecido. Los Media Partners conservan activo su rol de medios.',
            affiliateBadge: 'Medios + afiliados',
            licenseWindow: 'Periodo de licencia',
            accessRenewal: 'Renovación del acceso',
        },
        tiers: {
            trial: {
                name: 'Creador de prueba',
                range: '50–500 seguidores',
                copy: 'Usa la licencia inicial de 2 días para grabar tu primer vídeo de Dream. Cuando nuestro equipo lo apruebe, añadiremos 1 semana a tu licencia.',
                start: 'Licencia inicial de 2 días',
                renewal: 'Por cada vídeo aprobado: +1 semana de acceso',
            },
            established: {
                name: 'Creador establecido',
                range: 'Más de 500 seguidores',
                copy: 'Usa la licencia inicial de 1 semana para crear tu vídeo de Dream. Cuando nuestro equipo lo apruebe, añadiremos 1 mes a tu licencia.',
                start: 'Licencia inicial de 1 semana',
                renewal: 'Por cada vídeo aprobado: +1 mes de acceso',
            },
            partner: {
                name: 'Media Partner',
                range: 'Canales con gran afinidad',
                copy: 'Recibe el rol de medios con acceso continuo para creadores, enlaces de afiliado y pagos de comisiones. Los vídeos de Dream aprobados quedan registrados en tu actividad de colaboración.',
                start: 'Acceso con rol de medios',
                renewal: 'Vídeos aprobados registrados; el rol de medios sigue activo',
            },
        },
        guest: {
            title: '¿Listo para mostrar Dream?',
            copy: 'Solicita acceso con tu canal de Minecraft. Si te aceptamos, acordaremos el periodo de tu licencia y el contenido de Dream que publicarás.',
            createAccount: 'Crear una cuenta',
        },
        intake: {
            closedTitle: 'Las solicitudes de Media están cerradas',
            closedFallback: 'Las nuevas solicitudes de Dream Media no están disponibles temporalmente. Los espacios de creadores existentes siguen accesibles.',
        },
        apply: {
            title: 'Enséñanos tu canal de Minecraft.',
            copy: 'Estos datos nos ayudan a revisar si tu audiencia encaja, definir el periodo de licencia y acordar entregas de contenido realistas.',
            steps: {
                channel: 'Canal',
                channelCopy: 'Dónde publicas contenido de Minecraft',
                plan: 'Plan de contenido',
                planCopy: 'Cómo mostrarías Dream',
                review: 'Revisión de licencia',
                reviewCopy: 'Adaptamos el acceso a las entregas',
            },
            channelProfile: 'Perfil del canal',
            primaryPlatform: 'Plataforma principal',
            other: 'Otra',
            channelName: 'Nombre del canal',
            channelNamePlaceholder: 'Tu nombre como creador',
            channelUrl: 'URL del canal',
            followers: 'Seguidores / suscriptores',
            typicalViews: 'Visualizaciones habituales por publicación',
            contentLanguage: 'Idioma del contenido',
            languagePlaceholder: 'Español, inglés…',
            categories: 'Categorías del contenido',
            categoriesPlaceholder: 'Minecraft, PvP, tutoriales…',
            fitTitle: 'Contenido y encaje de licencia',
            experience: 'Cuéntanos tu experiencia creando contenido',
            experiencePlaceholder: '¿Cuánto tiempo llevas creando y qué contenido funciona mejor?',
            motivation: '¿Por qué quieres unirte a Dream Media?',
            motivationPlaceholder: '¿Por qué Dream encaja con tu audiencia de Minecraft?',
            feature: '¿Cómo mostrarías Dream?',
            featurePlaceholder: 'Comparte ideas de vídeos, Shorts, TikToks o directos y un calendario de publicación realista.',
            agreement: 'Confirmo que estos datos son correctos y entiendo que cada ampliación de licencia se concede cuando el equipo de Dream aprueba un vídeo publicado.',
            submitting: 'Enviando…',
            submit: 'Enviar solicitud',
        },
        workspace: {
            titleDefault: 'Espacio de Media Partner',
            titles: {
                submitted: 'Tu solicitud está en marcha.',
                under_review: 'Tu solicitud está en marcha.',
                needs_info: 'Tu solicitud necesita una respuesta.',
                accepted: 'Te damos la bienvenida a Dream Media.',
                declined: 'Tu solicitud ha sido revisada.',
                closed: 'Tu solicitud ha sido cerrada.',
            },
            copies: {
                submitted: 'Sigue el progreso y habla directamente con el equipo sin salir de tu cuenta.',
                under_review: 'Sigue el progreso y habla directamente con el equipo sin salir de tu cuenta.',
                needs_info: 'El equipo necesita hacerte una pregunta antes de tomar una decisión.',
                accepted: 'Gestiona periodos de licencia, entregas de contenido, seguimientos y tu relación continua con el equipo de Dream.',
                declined: 'Consulta la decisión. Puedes enviar una solicitud mejorada cuando estés listo.',
                closed: 'Revisa el motivo del cierre. Podrás crear una nueva solicitud cuando se vuelvan a abrir.',
            },
            applicationNumber: 'Solicitud n.º {id}',
            progress: 'Progreso de la solicitud',
            submitted: 'Enviada',
            review: 'Revisión',
            decision: 'Decisión',
            partnership: 'Colaboración',
            needsInfoTitle: 'El equipo necesita más información',
            needsInfoCopy: 'Lee la última actualización y responde en la conversación.',
            declinedTitle: 'Esta vez no ha sido aceptada',
            declinedFallback: 'El equipo ha decidido no continuar con esta solicitud.',
            closedTitle: 'Solicitud cerrada',
            closedFallback: 'El equipo de Dream cerró esta solicitud sin marcarla como rechazada.',
            reapply: 'Crear una nueva solicitud',
            activeRoleCopy: 'Tu rol de medios está activo. El acceso a la licencia del producto se concede para el plan de contenido acordado con el equipo de Dream.',
            starterAccessCopy: 'Tu licencia inicial de {product} está activa para el plan de contenido acordado con el equipo de Dream.',
            basicProduct: 'Dream Basic',
            advancedProduct: 'Dream Advanced',
            licenseExpires: 'La licencia caduca',
            lifetimeAccess: 'Ya tienes acceso de por vida',
            lifetimeAccessCopy: 'Tu licencia vitalicia actual no necesita ampliaciones. Aun así, puedes enviar contenido publicado para su revisión y registro en el programa.',
            licenseRenewalCopy: 'Envía un vídeo de Dream publicado para que lo aprobemos y conseguir la ampliación de acceso de tu nivel.',
            nextFollowUp: 'Próximo seguimiento',
            notScheduled: 'Sin programar',
            followUpCopy: 'El equipo publicará cualquier cambio de calendario en tu actividad.',
            affiliateSystem: 'Sistema de pagos de afiliados',
            creatorLink: 'Enlace de creador',
            preparingCode: 'Estamos preparando tu código',
            affiliateCopy: 'Tu enlace de afiliado con seguimiento y las herramientas de pago de comisiones están disponibles en Referidos.',
            referralCopy: 'Tu espacio de referidos está disponible en la barra lateral.',
            conversation: 'Conversación de la solicitud',
            updateCount: '{count} actualizaciones',
            dreamTeam: 'Equipo de Dream',
            viewContent: 'Ver contenido enviado',
            contentPending: 'Pendiente de revisión',
            contentApproved: 'Aprobado',
            extendedUntil: 'Licencia ampliada hasta el {date}',
            approvedNoExtension: 'Aprobado; no era necesaria una ampliación temporal',
            messagePlaceholder: 'Escribe un mensaje al equipo de medios de Dream…',
            sendMessage: 'Enviar mensaje',
            submitContentTitle: 'Enviar contenido publicado',
            submitContentCopy: 'Comparte aquí cada vídeo o publicación para que el equipo pueda revisarlo y hacer seguimiento.',
            publishedUrl: 'URL publicada',
            noteOptional: 'Nota (opcional)',
            notePlaceholder: 'Contexto, resultados o cualquier dato que el equipo deba conocer.',
            submitContent: 'Enviar contenido',
            channelSnapshot: 'Resumen del canal',
            platform: 'Plataforma',
            audience: 'Audiencia',
            typicalViews: 'Visualizaciones habituales',
            language: 'Idioma',
            categories: 'Categorías',
            applied: 'Solicitud enviada',
            legacyTitle: 'Tu acceso de medios está activo.',
            legacyCopy: 'Tu cuenta ya tiene el rol de Dream Media. Puedes acceder a referidos, descargas, configuraciones y recursos para creadores desde el panel.',
            openReferrals: 'Abrir referidos',
        },
        status: {
            submitted: 'Enviada',
            under_review: 'En revisión',
            needs_info: 'Respuesta necesaria',
            accepted: 'Aceptada',
            declined: 'Rechazada',
            closed: 'Cerrada',
        },
        program: {
            onboarding: 'Incorporación',
            active: 'Activo',
            paused: 'En pausa',
            inactive: 'Inactivo',
            invited: 'Invitado',
        },
        messages: {
            loadError: 'No se pudo cargar Media Hub',
            applicationSubmitted: 'Tu solicitud de medios ha sido enviada',
            applicationError: 'Revisa tus respuestas e inténtalo de nuevo.',
            messageSent: 'Mensaje enviado',
            messageError: 'No se pudo enviar el mensaje',
            contentSubmitted: 'Contenido enviado para revisión',
            contentError: 'No se pudo enviar el contenido',
        },
    },    footer: {
        product: 'Producto',
        account: 'Cuenta',
        community: 'Comunidad',
        terms: 'Términos del servicio',
        rights: 'Todos los derechos reservados.',
        disclaimer: 'Dream no está afiliado con Mojang AB ni Microsoft.',
    },
};
